import React from 'react';
import { Box, Image, Paragraph } from '@zillow/constellation-10';
import DataCard from 'app/shared/components/DataCard';
import { Temperature } from 'app/shared/types/Temperature';

import Cool from 'images/marketTemperature/cool.svg';
import Warm from 'images/marketTemperature/warm.svg';
import Hot from 'images/marketTemperature/hot.svg';

interface MarketTemperatureProps {
  areaName: string;
  temp: Temperature;
  isSmallScreen: boolean;
}

const MarketTemperature: React.FunctionComponent<
  React.PropsWithChildren<React.PropsWithChildren<MarketTemperatureProps>>
> = (props) => {
  const { areaName, temp, isSmallScreen } = props;

  return temp === Temperature.unknown ? null : (
    <DataCard
      heading="Market temperature"
      copyText={`The ${areaName} rental market temperature is ${temp}. Market temperature is based on changes in renter demand compared to the national average. For example, a hot market has increasing demand.`}
      useFullScreen={isSmallScreen}
    >
      <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBlock: '600' }}>
        {temp === Temperature.cool && <Image src={Cool.src} alt="cool" height={218} width={229} />}
        {temp === Temperature.warm && <Image src={Warm.src} alt="warm" height={218} width={229} />}
        {temp === Temperature.hot && <Image src={Hot.src} alt="hot" height={218} width={229} />}
        <Paragraph color="text.subtle" textStyle="body-sm" css={{ marginTop: '800' }}>
          Temperature is based on all bedrooms and all property types.
        </Paragraph>
      </Box>
    </DataCard>
  );
};

export default MarketTemperature;
